import { ConfigType } from '@/hooks/useConfig';

export let specUrls = [{ name: '', url: '' }];

export const setSpecUrls = (data: ConfigType[]) => {
  specUrls = data;
};

export const hasSpecUrls = (urls: ConfigType[]): boolean => {
  return urls && urls[0]?.url !== '';
};

export const getSpecUrl = (urls: ConfigType[], primaryName: string): string => {
  if (!primaryName) return '';
  if (!hasSpecUrls(urls)) return '';
  const currentUrls = urls.filter(({ name }) => name === primaryName);
  if (currentUrls.length === 0) throw new Error('Unknown primary name');
  return currentUrls[0].url;
};
